exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PopoverBody .ExpressionPopover {\n  width: 480px;\n}\n", ""]);

// exports
